<template lang='pug'>
  div
    v-tooltip(bottom)
      template(v-slot:activator='{on}')
        v-btn.tight-button(v-on='on' icon @click='open()')
          v-icon sort
      span Change Sort Order
    v-dialog(v-model='showSortOrderDialog' max-width='500px' @input="v => v || cancel()")
      v-card
        v-card-title
          h3.text-h5.font-weight-light Sort Order
        sortable-list(ref='sortableList' :value='value' @input='updateSortOrder')
          template(v-slot:row='{item, index}')
            div.ml-2
              .text-subtitle-1 {{ item.name }}
              .text-caption.grey--text(v-if='item.gitBranch') {{item.gitBranch}}
        v-card-actions
          v-spacer
          v-btn(text @click='cancel()') Cancel
          v-btn(color='primary' @click='save()' text :loading='saving') Save
</template>

<script>
import {clone} from 'lodash';
import SortableList from './SortableList';
import Notifications from '../services/notification.service';
import Summary from '../api/summary';

export default {
  name: 'BionicMetricsSortOrder',
  components: {SortableList},
  props: ['value'],
  methods: {
    open() {
      this.original = clone(this.value);
      this.sortOrder = this.value.map((dashboard, i) => ({guid: dashboard.guid, sortOrder: i}));
      this.showSortOrderDialog = true;
    },
    close() {
      this.showSortOrderDialog = false;
    },
    cancel() {
      this.$emit('input', this.original);
      this.close();
    },
    async save() {
      this.saving = true;
      try {
        await Summary.setSortOrder(this.sortOrder);
        await Notifications.toast('Sort order saved');
        this.close();
      } finally {
        this.saving = false;
      }
    },
    async updateSortOrder(items) {
      this.sortOrder = items.map((item, i) => ({guid: item.guid, sortOrder: i}));
      this.$emit('input', items);
    }
  },
  data() {
    return {
      saving: false,
      sortOrder: null,
      showSortOrderDialog: false,
      original: null
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tight-button {
  margin: 0;
  padding: 0;
}
</style>
